import InternalLink from "./Link";
import { MuiIcons, Mui } from "@osu/react-ui";
import { Fragment, useState } from "react";
import usePaperStyleProps from "../../Common/hooks/usePaperStyleProps";
import Favorites from "./Favorites";

const sizingStyles = (theme) => {
  return {
    minHeight: "44px",
    [`& .${Mui.buttonClasses.endIcon}`]: {
      marginRight: 0
    }
  };
};

export default function FavoritesDropdown({ className }) {
  const paperStyles = usePaperStyleProps();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event, toggle = false) => {
    setAnchorEl((existing) => {
      if (toggle && existing) {
        return null;
      }
      return event.currentTarget;
    });
  };
  return (
    <Fragment>
      <InternalLink
        className={className}
        size="small"
        startIcon={<MuiIcons.Bookmark />}
        endIcon={<MuiIcons.ArrowDropDown />}
        sx={[sizingStyles, (theme) => theme.typography.subtitle2]}
        onClick={(event) => handleOpen(event, true)}
        aria-controls={open ? id : undefined}
        aria-haspopup={true}
        aria-expanded={open ? true : undefined}
      >
        Bookmarks
      </InternalLink>
      <Mui.Menu
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          zIndex: paperStyles?.zIndex?.navbar + 200
        }}
      >
        <Favorites sx={{
          maxWidth: '25rem',
          textWrap: 'wrap'
        }} />
      </Mui.Menu>
    </Fragment>
  );
}
